<template>
  <header class="nav_topNavbar">
    <div class="logoBox">
      <router-link to="/" class="logo">
         <h1>Qwic</h1>
      </router-link>
    </div>
    <nav class="clearfix">
      <div class="navbar-nav" v-if='notInHome'>
        <ul class="navbar_topMenu list-unstyled">
          <li :data-tit="$t('navbar.date')">{{ getCurrentDate || '--' }}</li>
          <li :data-tit="$t('navbar.odo')">{{ getAllBikeInfoList.bikeInfoList ? getAllBikeInfoList.bikeInfoList.ODO : '--' }} km</li>
          <li :data-tit="$t('navbar.bikeModel')">{{ getBikeModel || '--' }}</li>
          <li :data-tit="$t('navbar.frameNo')">{{ frameNo || '--' }}</li>
        </ul>
      </div>
      <div class="navbar-right">
        <ul class="navbar_rightMenu list-unstyled">
          <li v-if='notInHome'>
            <a href="javascript:void(0)" @click="funcHandleClear">
              <i class="icon-bikechange"></i>
            </a>
          </li>
          <li>
            <select id="btnSelectLng" class="selectpicker" data-width="fit" data-styleBase="" data-style="btn_flag" ref="langSelect" v-model="language">
              <option v-for="opl  in langData" :key="opl.lang" :data-content="opl.icon" :value="opl.lang"> {{ opl.lang }} </option>
            </select>
          </li>
        </ul>
      </div>
    </nav>
  </header>
</template>

<script>
import { mapGetters } from 'vuex';
import * as Sentry from '@sentry/browser';
import ls from '@/utils/local-storage';

export default {
  data () {
    return {
      langData: [
        { lang: 'en', icon: '<span class="flag-icon flag-icon-gb"></span>' },
        { lang: 'de', icon: '<span class="flag-icon flag-icon-de"></span>' },
        { lang: 'nl', icon: '<span class="flag-icon flag-icon-nl"></span>' }
      ],
      language: this.getNowLanguage()
    };
  },
  mounted () {
    $(this.$refs.langSelect).selectpicker('refresh');
  },
  computed: {
    ...mapGetters({
      getBikeInfo: 'bikeConnect/getBikeInfo',
      getCurrentDate: 'bikeConnect/getCurrentDate',
      getAllBikeInfoList: 'bikeInformation/getAllBikeInfoList',
      getBikeFrameNo: 'bikeConnect/getBikeFrameNo',
      getBikeModel: 'bikeInformation/getBikeModel'
    }),
    bikeModel () {
      return this.getBikeInfo ? this.getBikeModel : '--';
    },
    frameNo () {
      return this.getBikeFrameNo ? this.getBikeFrameNo : '--';
    },
    notInHome () {
      return this.$route.path !== '/';
    },
    bikeODOError () {
      try {
        return this.getAllBikeInfoList.bikeInfoList;
      } catch (e) {
        Sentry.captureMessage(`bikeInfoList went wrong. ${e}`);
        return null;
      }
    }
  },
  watch: {
    language: function (val) {
      ls.setItem('lang', val);
      this.$store.dispatch('bikeConnect/setLang', val);
      this.$i18n.locale = val;
    }
  },
  methods: {
    funcHandleClear () {
      this.$store.commit('clearCache');
      this.$store.dispatch('bikeConnect/setBikeFlag', true);
      this.$router.push({ name: 'Home' });
    },
    getNowLanguage () {
      let lsLang = ls.getItem('lang');
      let returnLang = '';
      let defaultLang = 'en';
      if (lsLang) {
        returnLang = lsLang;
      } else {
        returnLang = defaultLang;
      }
      return returnLang;
    }
  }
};
</script>

<style lang="scss">
.navbar_rightMenu {
  .bootstrap-select.dropdown {
    top: 14px;
  }
}
</style>
